function execute(store, generator, yieldValue) {
  const yieldResult = generator.next(yieldValue);

  // when I want to get symultaneously by yield []
  if (Array.isArray(yieldResult.value)) {
    const res = Promise.all(yieldResult.value.map(v => execute(store, v)))
      .then(values => execute(store, generator, values))
      .catch(err => {
        // TODO code block not tested yet
        const throwResult = generator.throw(err);
        if (throwResult.done) {
          return store.dispatch(throwResult.value);
        }
        return execute(store, generator, throwResult);
      });
    return res;
  }

  // when I want to get state by (s) => s
  if (typeof yieldResult.value === 'function') {
    return execute(store, generator, yieldResult.value(store.getState()));
  }

  if (!yieldResult.done) {
    if (yieldResult.value && yieldResult.value.type) {
      store.dispatch(yieldResult.value);
    }

    if (yieldResult.value && typeof yieldResult.value.then === 'function') {
      return yieldResult.value.then(
        promiseResult => execute(store, generator, promiseResult),
        err => {
          const throwResult = generator.throw(err);
          if (throwResult.done) {
            return store.dispatch(throwResult.value);
          }
          return execute(store, generator, throwResult);
        }
      );
    }

    return execute(store, generator, yieldResult);
  }

  if (yieldResult.value && yieldResult.value.type) {
    return store.dispatch(yieldResult.value);
  }

  return yieldResult.value;
}

export default function getGeneratorMiddleware() {
  return store => next => action => {
    if (typeof action.next === 'function') {
      return execute(store, action);
    }
    return next(action);
  };
}
